import { db } from '../firebase';
import { doc, setDoc, updateDoc, serverTimestamp, deleteField } from 'firebase/firestore';

// ═══════════════════════════════════════════════════════════════════
//  SYARAT READY + AUTO-PULIH KAD PENDING
//
//  KEMBAR bagi logik yang sama dalam extension:
//    sesaat (extension)/components/ImportProductsView.tsx
//      → evaluateProductData() + blok "DATA PRODUK"
//  Dua codebase TIDAK kongsi kod. Kalau syarat atau format blok berubah,
//  ubah DUA-DUA tempat.
//
//  ⚠️ BEZA SENGAJA DARI EXTENSION (keputusan user 2026-07-29):
//  Syarat "WAJIB salah satu: Specification ATAU Customer Reviews" DIBUANG
//  di sisi webapp. Sebab (disahkan pada data production 2026-07-29):
//    • 40 daripada 60 kad terbaru gagal HANYA pada syarat itu, walaupun
//      penerangan produk panjang & berisi.
//    • Produk yang SAMA di-scrape dua kali beza 3 minit: sekali dapat 17
//      spesifikasi (READY), sekali langsung tiada (PENDING) — description,
//      harga, kategori serupa perkataan demi perkataan. Jadi puncanya
//      halaman PDP TikTok belum sempat render seksyen speks/ulasan, bukan
//      produk yang kosong.
//    • Kad PENDING dikunci dalam modal Add Products → pelanggan scrape
//      tapi tetap tak boleh guna produk mereka sendiri.
//
//  Extension v3.8.2 yang sudah diedarkan masih menguji syarat lama dan
//  akan terus menyimpan sebahagian kad sebagai PENDING. Webapp yang
//  membetulkan keputusan itu — supaya pelanggan TIDAK perlu memasang
//  extension baharu. Bila extension seterusnya dibina, selaraskan syarat
//  di sana dan modul ini boleh dinipiskan kepada paparan sebab sahaja.
// ═══════════════════════════════════════════════════════════════════

// Ayat template TikTok — panjang, nampak berisi, tapi SIFAR maklumat produk.
// Ini BUKAN keterangan produk; ia iklan TikTok Shop sendiri.
const TIKTOK_BOILERPLATE_DESC = /Buy .{1,140} on TikTok Shop|Discover great prices|free shipping on eligible items|Shop now for exclusive deals/i;

// ⛔ TIADA SYARAT PANJANG MINIMUM (keputusan user 2026-07-29 — jangan
// kembalikan tanpa tanya). Dahulu description wajib ≥150 aksara. Ia dibuang
// kerana:
//   • Banyak penjual TikTok memang menulis pendek (cth senarai warna sahaja)
//     atau meletakkan keterangan di dalam gambar. Produk itu sah, cuma
//     teksnya sedikit — tiada sebab menghalang pelanggan menggunakannya.
//   • Diukur pada 6,000 kad: syarat panjang hanya menyekat 11 daripada 74
//     kad yang benar-benar ada data. Kos kekecewaan jauh melebihi faedahnya.
//   • Arahan user: permudahkan pelanggan.
// Yang tinggal hanyalah tiga perkara yang memang mesti ada untuk AI menulis:
// keterangan (apa-apa panjang), harga, kategori.
//
// Nama medan kekal English — sama macam label borang dalam extension,
// senang pelanggan padankan bila kena lengkapkan data.
/* ⭐ SYARAT DIPERMUDAH LAGI (arahan user 2026-08-16) — Harga dan Kategori
   TIDAK lagi wajib. Yang benar-benar diperlukan pipeline untuk menulis skrip
   ialah: nama produk · gambar · ID produk (link) · keterangan. Medan lain
   (harga, kategori, jenama, rating, terjual, variasi, spesifikasi, ulasan)
   tetap dihantar kepada AI apabila ada — ia BONUS yang menajamkan skrip,
   bukan pintu masuk.

   Kesan pada data sedia ada diukur dahulu, bukan diagak: 94,774 kad diimbas,
   53,318 PENDING — tetapi hanya 38 daripadanya langsung ada data scrape, dan
   ketiga-tiga puluh lapan itu tersekat oleh DESCRIPTION (kosong atau ayat umum
   TikTok), bukan oleh harga/kategori. Jadi pelonggaran ini menukar **0** kad
   sedia ada; ia hanya melapangkan jalan untuk kad baharu.

   Param `product` PILIHAN — nama/gambar/ID hidup pada dokumen produk, bukan
   dalam scrapedData. Pemanggil lama yang hanya menghantar `sd` kekal berfungsi
   (hanya keterangan disemak), jadi rupa lama tidak berubah perangai. */
export function evaluateProductData(sd, product) {
    const desc = String(sd?.description || '').trim();

    const missing = [];
    if (!desc) {
        missing.push('Description');
    } else if (TIKTOK_BOILERPLATE_DESC.test(desc)) {
        // Bukan gate panjang — ini menolak teks yang langsung bukan tentang
        // produk. Diukur pada 6,000 kad: 0 kad sebenar tersekat olehnya.
        missing.push('Description (ayat umum TikTok je)');
    }

    if (product) {
        if (!String(product.name || '').trim()) missing.push('Product Name');
        if (!String(product.imageUrl || '').trim()) missing.push('Product Image');
        // ID produk datang daripada link TikTok — itulah yang menjadikan kad
        // ini merujuk produk sebenar, dan ia dipakai untuk nama collection Flow.
        // ★ 2026-10-03 — item SHOPEE sengaja menyimpan `link` KOSONG (link itu dihantar
        //   kepada robot TikTok); rujukan produknya ialah `shopeeProductUrl`
        //   (utils/shopeeImport.js). Item TikTok tiada medan itu → perangai lama tepat.
        //   ★ (petang 3 Okt) `shopeeLink` (link affiliate) turut dikira — keputusan user: "satu link
        //   sudah memadai" (TikTok ATAU Shopee). Tanpa ini, produk yang hanya ada link Shopee
        //   yang ditampal tangan kekal PENDING walaupun borang berkata cukup.
        const adaRujukan = [product.link, product.shopeeProductUrl, product.shopeeLink].some((v) => String(v || '').trim());
        if (!adaRujukan) missing.push('Product ID');
    }

    return { ready: missing.length === 0, missing };
}

// ── Blok DATA PRODUK — SALIN TEPAT format extension ──
// Dihantar melalui slot `imageAnalysis` kerana itulah saluran sedia ada yang
// webapp dan server memang dah baca. Server melabelkannya "📦 DATA PRODUK"
// berdasarkan marker `sourceType: 'scrape-only'`.
const CAP_DESC = 1500;   // description panjang dipotong
const CAP_REVIEW = 200;  // satu ulasan
const MAX_REVIEWS = 5;
const MAX_VARIANTS = 10;

export function buildDataProdukBlock(sd) {
    if (!sd) return '';

    const sellingPointsText = Array.isArray(sd.sellingPoints)
        ? sd.sellingPoints.join('; ')
        : (sd.sellingPoints || '');
    const specsText = Array.isArray(sd.specifications)
        ? sd.specifications.map(s => `${s?.name || s?.key || ''}: ${s?.value || ''}`).join('; ')
        : (typeof sd.specifications === 'object' && sd.specifications !== null
            ? JSON.stringify(sd.specifications)
            : (sd.specifications || ''));

    const variantNames = Array.isArray(sd.variants)
        ? Array.from(new Set(sd.variants.map(v => (v?.name || '').trim()).filter(Boolean))).slice(0, MAX_VARIANTS)
        : [];
    const reviewLines = Array.isArray(sd.topReviews)
        ? sd.topReviews
            .filter(r => r && typeof r.text === 'string' && r.text.trim())
            .slice(0, MAX_REVIEWS)
            .map(r => {
                const bits = [`"${String(r.text).trim().slice(0, CAP_REVIEW)}"`];
                if (r.variant) bits.push(`(beli: ${r.variant})`);
                if (r.date) bits.push(`[${r.date}]`);
                return `  • ${bits.join(' ')}`;
            })
        : [];

    // ★ 2026-10-03 — data dari Shopee dilabel Shopee (teks ini dibaca AI). Selain nama
    //   platform, baris ini SAMA huruf demi huruf dengan kembar extension.
    const platformSumber = sd.source === 'shopee' ? 'Shopee' : 'TikTok';
    return [
        `DATA PRODUK (di-scrape terus dari halaman produk ${platformSumber} — bukan analisa AI):`,
        sd.category ? `- Kategori: ${sd.category}` : '',
        sd.brand ? `- Jenama: ${sd.brand}` : '',
        sd.rating !== undefined && sd.rating !== '' && sd.rating !== null
            ? `- Rating: ${sd.rating}/5${sd.ratingCount ? ` daripada ${sd.ratingCount} ulasan` : ''}` : '',
        sd.soldCount !== undefined && sd.soldCount !== '' ? `- Jumlah terjual: ${sd.soldCount}` : '',
        sd.shopName ? `- Kedai: ${sd.shopName}` : '',
        variantNames.length ? `- Pilihan/variasi: ${variantNames.join(' · ')}` : '',
        sellingPointsText ? `- Kelebihan utama: ${sellingPointsText}` : '',
        specsText ? `- Spesifikasi: ${specsText}` : '',
        sd.description ? `- Penerangan produk:\n${String(sd.description).slice(0, CAP_DESC)}` : '',
        reviewLines.length ? `- Ulasan pelanggan sebenar (guna sebagai bahan hook):\n${reviewLines.join('\n')}` : '',
    ].filter(Boolean).join('\n');
}

/* ══════════════════════════════════════════════════════════════════════
   DATA PRODUK UNTUK AGENT (Gem / custom GPT pelanggan) — 2026-08-21
   ══════════════════════════════════════════════════════════════════════
   Sebelum ini agent pelanggan hanya menerima NAMA + LINK + gambar. Semua
   data produk (kategori, spesifikasi, ulasan…) tidak pernah sampai kepada
   agent, sedangkan enjin pipeline biasa memang menerimanya sejak dahulu.

   ⛔⛔ DARI MANA DATANYA DATANG — jangan cari di tempat lain.
   Kad produk Workspace (`users/{uid}/products`) TIDAK menyimpan data ini
   sebagai medan berasingan. Disahkan dengan bacaan sebenar 2026-08-21:
   0 daripada 73 kad membawa `scrapedData`. Yang wujud ialah SATU perenggan
   siap tulis dalam `intelligenceData.imageAnalysis` (dalam subdoc
   `detail/text` selepas Split V2) — perenggan yang SAMA yang disuap kepada
   pipeline biasa, dan yang ditulis semula setiap kali pelanggan menyimpan
   borang "Edit Data Produk".

   ⚠️ Perenggan itu ada DUA bentuk dan kedua-duanya masih hidup:
      A) "DATA PRODUK (di-scrape terus…)" + senarai berlabel — bentuk semasa.
      B) "Product visual context (synthesized from scrape…)" — bentuk lama,
         masih melekat pada item library yang di-scrape sebelum Julai 2026.
      Sebab itu ia dihantar BULAT-BULAT tanpa ditapis: menapis bermakna
      menghurai teks yang bentuknya tidak dijamin, dan kegagalannya SENYAP
      (medan hilang tanpa sesiapa perasan).

   📌 KERJA SUSULAN (keputusan user 2026-08-21): simpanan data produk akan
      diasingkan ikut medan supaya "Agent Saya" boleh menapis data mengikut
      kehendak pelanggan. Kotak tanda per-medan HANYA boleh dibina selepas
      itu — lihat seksyen berkaitan dalam CLAUDE.md.

   ⚠️ Bahasa blok ini SENGAJA Melayu tetap — ia teks yang dibaca MESIN
      (agent), bukan antara muka. Ia mesti sama tidak kira pelanggan sedang
      memakai app dalam EN atau BM; kalau tidak, agent yang sama menerima
      dua bentuk mesej berbeza dan jawapannya berubah ikut bahasa app.

   ⚠️ HARGA sengaja diambil dari KAD, bukan dari perenggan — perenggan itu
      memang tiada harga (server pipeline menghantarnya berasingan sebagai
      medan produk). Tanpa baris ini, agent tidak pernah nampak harga. */
export function blokDataAgent(product) {
    if (!product) return '';
    const perenggan = String(product?.intelligenceData?.imageAnalysis || '').trim();
    const baris = [
        product.price ? `- Harga: ${String(product.price).trim()}` : '',
        product.originalPrice ? `- Harga asal: ${String(product.originalPrice).trim()}` : '',
        product.discount ? `- Diskaun: ${String(product.discount).trim()}` : '',
    ].filter(Boolean);

    if (!perenggan) {
        /* Tiada perenggan langsung → hantar harga sahaja, dengan tajuknya
           sendiri. Kalau harga pun tiada, pulangkan '' supaya pemanggil
           melangkau blok ini sepenuhnya: tajuk kosong membaca sebagai data
           hilang, bukan data tiada. */
        return baris.length ? `DATA PRODUK:\n${baris.join('\n')}` : '';
    }
    /* Harga ditambah DI HUJUNG perenggan, bukan di atasnya — kedua-dua bentuk
       perenggan memang senarai bertanda '-', jadi baris harga menyambung
       kemas tanpa perlu menyentuh atau menghurai teks sedia ada. */
    return baris.length ? `${perenggan}\n${baris.join('\n')}` : perenggan;
}

/* Mesej yang SESAAT taip kepada agent = nama + link (ditampal oleh extension)
   + blok ini. Data dahulu, ayat arahan pelanggan KEMUDIAN — ayat terakhir
   dalam satu mesej paling melekat pada AI, jadi arahan tidak boleh tenggelam
   di bawah senarai spesifikasi.
   ⛔ Dipakai oleh KEDUA-DUA laluan larian; jangan salin logik ini di tempat
      lain (lihat nota blokDataAgent). */
export function gabungArahanAgent(product, agent) {
    const blok = blokDataAgent(product);
    const arahan = String(agent?.extraInstruction || '').trim();
    return [blok, arahan].filter(Boolean).join('\n\n');
}

export function buildIntelligenceFromScrape(sd, email) {
    return {
        imageAnalysis: buildDataProdukBlock(sd),
        webResearch: '',
        generatedAt: serverTimestamp(),
        generatedBy: email || '',
        sourceType: 'scrape-only', // marker — bezakan dari intelligence jana OpenAI
    };
}

// ── Sebab PENDING untuk paparan UI ──
// Pulangkan ayat LENGKAP — pemanggil papar terus tanpa menambah awalan.
// Utamakan `pendingReason` yang tersimpan (auto-pulih sentiasa menulisnya
// semula ikut syarat SEMASA, jadi ia tidak basi). Kalau kad langsung tiada
// data scrape, beri arahan yang berguna, bukan senarai medan kosong.
/* Param KEDUA `t` — fungsi terjemahan, pilihan.
   Tanpa ia, ayat Melayu di bawah dipulangkan sebagaimana dahulu; itulah yang
   dimahukan oleh pemanggil rupa LAMA (ProductLibraryModal) dan oleh halaman
   Products ketika suis v3.9 mati. Halaman v3.9 menghantar `t` masuk supaya
   ayat ini tidak tinggal sebagai satu baris Melayu di bawah setiap kad dalam
   skrin English.
   ⚠️ Nama medan di dalam `pendingReason` (Description, Price, Category…)
      datang daripada data yang ditulis semasa scrape — ia BUKAN ayat UI dan
      sengaja tidak diterjemah. */
export function pendingReasonText(product, t) {
    if (!product || product.hasIntelligence) return null;
    const T = (kunci, lalai, vars) => (t ? t(kunci, vars) : lalai);

    const hasScrape = !!(product.scrapedData || product.hasScrapedData);
    if (!hasScrape) {
        return T('products.pending.noData', 'Belum ada data produk — scrape melalui Import Products di Extension.');
    }
    if (product.pendingReason) {
        const fields = String(product.pendingReason).replace(/^Data tidak lengkap:\s*/i, '').trim();
        return fields
            ? T('products.pending.missing', `Belum ada: ${fields}`, { medan: fields })
            : T('products.pending.incomplete', 'Data produk belum lengkap.');
    }
    if (product.scrapedData) {
        const { missing } = evaluateProductData(product.scrapedData);
        if (missing.length) {
            return T('products.pending.missing', `Belum ada: ${missing.join(', ')}`, { medan: missing.join(', ') });
        }
    }
    return T('products.pending.incomplete', 'Data produk belum lengkap.');
}

// ═══════════════════════════════════════════════════════════════════
//  AUTO-PULIH — kad PENDING yang sebenarnya sudah cukup data
//
//  Berjalan senyap bila senarai produk dimuatkan (page Products DAN modal
//  Add Products). Pelanggan tidak perlu tekan apa-apa — selaras prinsip
//  bulk-first.
//
//  Skop: kad MILIK pelanggan sendiri sahaja (group 'own' + addedBy). Kad
//  System (admin-curated) TIDAK disentuh — admin ada alat sendiri.
//
//  ⛔⛔ JANGAN GABUNGKAN TULISAN INI KE DALAM writeBatch (pepijat sebenar
//  2026-07-29, pelanggan terjejas). Peraturan keselamatan bagi subdoc
//  payload memanggil get() pada doc induk untuk menyemak pemilik. Firestore
//  hadkan panggilan get() kepada 20 bagi SATU batched write — sedangkan
//  satu batch 43 kad memerlukan lebih 80. Firestore menolak SELURUH batch,
//  jadi 0 kad dipulihkan walaupun 43 layak. Ia lulus pada akaun ujian
//  (kad sedikit) dan gagal senyap pada akaun pelanggan sebenar.
//  Tulisan per-kad = setiap permintaan dinilai berasingan (had 10 setiap
//  satu, kita guna ~2) → had tidak pernah tercapai, walau 500 kad.
//  Kos TIDAK berubah: Firestore mengecaj setiap dokumen, bukan setiap batch.
//
//  Kos seumur kad (sekali sahaja, tidak berulang):
//    • kad dipulihkan     — 2 tulisan (subdoc teks + bendera pada kad)
//    • kad tak layak      — 1 tulisan (sebab PENDING), kemudian dilangkau
//    • kad tanpa scrape   — 0 tulisan
//  Teks berat sengaja disimpan dalam subdoc, BUKAN pada kad — supaya
//  senarai produk kekal ringan setiap kali dibuka (itu kos berulang yang
//  jauh lebih besar daripada tulisan sekali ini).
// ═══════════════════════════════════════════════════════════════════

// Kad yang sudah dinilai dalam sesi ini — elak kerja berulang bila
// onSnapshot menembak berkali-kali. Kegagalan TIDAK direkod, supaya ia
// boleh dicuba semula pada muat seterusnya.
const attemptedThisSession = new Set();

// Berapa kad ditulis serentak. Rendah dengan sengaja — pulih adalah kerja
// latar, jangan bersaing dengan bacaan yang pelanggan sedang tunggu.
const WRITE_CONCURRENCY = 5;

// Pulangan `updates` membolehkan pemanggil menampal state tempatan tanpa
// membaca semula senarai (ProductLibraryModal guna onSnapshot, jadi ia
// menampal sendiri dan boleh abaikan medan ini).
export async function repairPendingLibraryCards({ folderId, products, email }) {
    const result = { repaired: 0, stillPending: 0, failed: 0, updates: [] };
    if (!folderId || !email || !Array.isArray(products) || products.length === 0) return result;

    const candidates = products.filter(p =>
        p && !p.hasIntelligence
        && p.group === 'own'
        && p.addedBy === email
        && !attemptedThisSession.has(`${folderId}/${p.id}`)
    );
    if (candidates.length === 0) return result;

    // Nilai guna scrapedData yang MEMANG dah datang bersama senarai — sifar
    // bacaan tambahan. Kad yang datanya sudah dipindah ke subdoc (schema v2)
    // sengaja dilangkau: membacanya bermakna satu bacaan per kad SETIAP kali
    // page dibuka, iaitu kos berulang. Kad begitu kekal PENDING dan papar
    // sebabnya. Setakat ini kad pelanggan menyimpan scrapedData pada kad.
    const tasks = [];
    for (const p of candidates) {
        const key = `${folderId}/${p.id}`;
        const sd = p.scrapedData;
        if (!sd) {
            attemptedThisSession.add(key);
            result.stillPending += 1;
            continue;
        }
        // Harga boleh datang dari kad (pelanggan set sendiri di My Products) walaupun
        // scrape tidak menemuinya — sama macam extension buat masa Import. Tanpa ini
        // kad berharga-manual kekal PENDING sedangkan harganya memang diketahui.
        const sdEval = { ...sd, price: sd.price || p.price || '' };
        const { ready, missing } = evaluateProductData(sdEval);
        if (ready) {
            tasks.push({ product: p, ready: true, sd: sdEval });
            continue;
        }
        // Tulis semula sebab ikut syarat SEMASA supaya kad tidak papar alasan
        // lama yang sudah tidak terpakai. Langkau kalau memang sama — inilah
        // yang menghalang tulisan berulang setiap kali page dibuka.
        const reason = `Data tidak lengkap: ${missing.join(', ')}`;
        if (p.pendingReason === reason) {
            attemptedThisSession.add(key);
            result.stillPending += 1;
        } else {
            tasks.push({ product: p, ready: false, reason });
        }
    }
    if (tasks.length === 0) return result;

    let cursor = 0;
    const worker = async () => {
        while (cursor < tasks.length) {
            const t = tasks[cursor++];
            const key = `${folderId}/${t.product.id}`;
            const itemRef = doc(db, 'library', folderId, 'items', t.product.id);
            try {
                if (!t.ready) {
                    await updateDoc(itemRef, { pendingReason: t.reason });
                    result.stillPending += 1;
                    result.updates.push({ id: t.product.id, pendingReason: t.reason });
                } else {
                    // Teks DULU, bendera KEMUDIAN. Kalau teks gagal ditulis, kad
                    // kekal PENDING — selamat. Terbalik = kad bertanda READY tanpa
                    // teks, dan Generate akan gagal di tangan pelanggan.
                    await setDoc(
                        doc(db, 'library', folderId, 'items', t.product.id, 'payload', 'data'),
                        {
                            intelligenceJson: buildIntelligenceFromScrape(t.sd, email),
                            updatedAt: serverTimestamp(),
                            updatedBy: email,
                        },
                        { merge: true },
                    );
                    const parentUpdate = { hasIntelligence: true, pendingReason: null };
                    // Buang salinan inline lama (item schema v1) — elak dua sumber.
                    if (t.product.intelligenceJson) parentUpdate.intelligenceJson = deleteField();
                    // ⚠️ SENGAJA tidak menyentuh `updatedAt` doc induk — My Products
                    // menyusun ikut medan itu. Pulih senyap tidak boleh mengubah
                    // susunan kad pelanggan.
                    await updateDoc(itemRef, parentUpdate);
                    result.repaired += 1;
                    result.updates.push({ id: t.product.id, hasIntelligence: true, pendingReason: null });
                }
                attemptedThisSession.add(key);
            } catch (err) {
                // Jangan tanda "sudah dicuba" — biar muat seterusnya cuba lagi.
                result.failed += 1;
                if (result.failed <= 3) {
                    console.warn('[productReady] gagal pulih kad', t.product.id, err?.code || err?.message);
                }
            }
        }
    };
    await Promise.all(
        Array.from({ length: Math.min(WRITE_CONCURRENCY, tasks.length) }, () => worker()),
    );

    if (result.repaired > 0) {
        console.log(`[productReady] ${result.repaired} kad PENDING dipulihkan → READY.`);
    }
    if (result.failed > 0) {
        console.warn(`[productReady] ${result.failed} kad GAGAL dipulihkan — akan dicuba semula bila page dibuka lagi.`);
    }
    return result;
}

// ═══════════════════════════════════════════════════════════════════
//  DATA DITAIP SENDIRI OLEH PELANGGAN
//
//  Wujud kerana sesetengah penjual TikTok meletakkan keterangan produk
//  di dalam GAMBAR sahaja — halaman itu memang tiada teks untuk di-scrape,
//  berapa kali pun dicuba. Tanpa laluan ini, produk begitu tidak akan
//  boleh digunakan selama-lamanya walaupun ia produk yang bagus.
//
//  Ditulis ke medan yang SAMA dengan hasil scrape (`scrapedData`), jadi
//  tiada laluan istimewa di hilir — penilaian READY, blok DATA PRODUK dan
//  Generate semuanya berjalan seperti biasa.
// ═══════════════════════════════════════════════════════════════════
/* `bonus` — medan scrape LAIN yang turut menyuap AI (jenama, rating, terjual,
   kedai, variasi, kelebihan, spesifikasi, ulasan). Semuanya PILIHAN: hantar
   apa yang pengguna ubah, biarkan yang lain. Nilai `undefined` bermakna
   "jangan sentuh" — bukan "kosongkan" — supaya borang yang tidak memaparkan
   sesuatu medan tidak memadamkannya secara senyap.
   `productPatch` — nama/gambar/link yang baru disimpan oleh pemanggil; ia
   dipakai untuk menilai READY, kerana medan itu hidup pada dokumen produk. */
export async function saveManualProductData({ folderId, product, email, description, price, category, bonus, productPatch }) {
    if (!folderId || !product?.id || !email) throw new Error('Maklumat tidak lengkap untuk menyimpan.');

    const sd = { ...(product.scrapedData || {}) };
    sd.description = String(description ?? '').trim();
    sd.price = String(price ?? '').trim();
    sd.category = String(category ?? '').trim();

    if (bonus && typeof bonus === 'object') {
        for (const [kunci, nilai] of Object.entries(bonus)) {
            if (nilai !== undefined) sd[kunci] = nilai;
        }
    }
    // Jejak sumber — supaya kemudian hari boleh dibezakan daripada hasil scrape.
    sd.manualEntry = true;

    const { ready, missing } = evaluateProductData(sd, { ...product, ...(productPatch || {}) });
    const itemRef = doc(db, 'library', folderId, 'items', product.id);

    if (ready) {
        // Teks DULU, bendera KEMUDIAN — sama sebab macam auto-pulih: kad tidak
        // boleh bertanda READY sedangkan teksnya gagal disimpan.
        await setDoc(
            doc(db, 'library', folderId, 'items', product.id, 'payload', 'data'),
            {
                intelligenceJson: buildIntelligenceFromScrape(sd, email),
                updatedAt: serverTimestamp(),
                updatedBy: email,
            },
            { merge: true },
        );
    }

    const patch = {
        scrapedData: sd,
        hasIntelligence: ready,
        pendingReason: ready ? null : `Data tidak lengkap: ${missing.join(', ')}`,
        // Ini suntingan yang pelanggan buat sendiri, jadi kad memang patut naik
        // ke atas senarai — berbeza daripada auto-pulih yang senyap.
        updatedAt: serverTimestamp(),
        updatedBy: email,
    };
    if (sd.price) patch.price = sd.price;          // kekalkan harga kad selaras
    if (ready && product.intelligenceJson) patch.intelligenceJson = deleteField();

    await updateDoc(itemRef, patch);

    // Benarkan auto-pulih menilai kad ini semula dalam sesi yang sama.
    attemptedThisSession.delete(`${folderId}/${product.id}`);

    return { ready, missing, scrapedData: sd, pendingReason: patch.pendingReason };
}
